import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import Modal from "react-modal";
import InputField from "../../components/inputFields/InputField";
import FormikDropdown from "../../components/inputFields/FormikDropDown";
import { Form, Formik } from "formik";
import Button from "../../components/buttons/Button";
import { toast } from "react-toastify";
import { allotMedicine } from "../../services/clinic/medicine";
import StyledHeadingText from "../../components/Fonts/StyledHeadingText";
import { getCenters } from "../../services/clinic/centers";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    maxWidth: "95%", // Responsive for mobile
    zIndex: 1050,
    padding: "20px",
  },
  overlay: {
    zIndex: 1040,
    backgroundColor: "rgba(0, 0, 0, 0.75)",
  },
};

Modal.setAppElement("#root");

const AllotOpenMedicineAlert = ({ isOpen, onRequestClose, onSave, contentLabel, providedValues }) => {

  const handleFormSubmit = async (values, { setSubmitting }) => {
    try {
      const formData = new FormData();
      formData.append("medicine", providedValues.id);
      formData.append("quantity_alloted", values.quantity);
      formData.append("center", values.center);
      formData.append("alloted_by", values.alloted_by);
      const response = await allotMedicine(formData);

      if (response?.status === 201) {
        toast.success("Medicine Alloted successfully!");
        if (onSave) {
          onSave();
        }
        onRequestClose();
      } else {
        let errors = "Opps! Something went wrong, please try again.";
        toast.error(errors);
      }
    } catch (error) {
      let errors =
        error?.response?.data?.error ||
        "Opps! Something went wrong, please try again.";
      toast.error(errors);
    }
    setSubmitting(false);
  };

  const handleDiscardChanges = (resetForm) => {
    resetForm();
    onRequestClose();
  };

  const [centers, setCenters] = useState([]);

  const fetchCenters = async () => {
    try {
      let res = await getCenters("?page_size=50");
      if (res.status === 200) {
        setCenters(res.data.results);
      } else {
        toast.error("Unable to fetch centers");
      }
    } catch (error) {
      console.error("Error fetching centers:", error);
    }
  };


  useEffect(() => {
    fetchCenters();
  }, []);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={customStyles}
      contentLabel={contentLabel}
    >
      <div className="max-w-2xl">
        <StyledHeadingText text={"Add Quantity"} />
        <Formik
          initialValues={{
            center: "",
            quantity: "",
            alloted_by: "",
          }}
          validationSchema={Yup.object({
            center: Yup.string().required("Please select Center"),
            quantity: Yup.number().required("Please enter an quantity").max(providedValues.stock_qt),
            alloted_by: Yup.string().required("Please provide your name"),
          })}
          onSubmit={handleFormSubmit}
        >
          {({ isSubmitting, resetForm, values }) => (
            <Form>
              <div className="border border-gray-300 mt-5 p-4 rounded-lg bg-gray-100 h-96">
                <div className="grid gap-6 md:grid-cols-3">
                  <FormikDropdown
                    label="Center"
                    name="center"
                    placeholder="Select Center"
                    options={centers.map((center) => ({
                      value: center.id,
                      label: center.name,
                    }))}
                    required={true}
                    needSearch
                  />
                  <InputField
                    label="Quantity Issued"
                    name="quantity"
                    type="text"
                    placeholder="130"
                    required={true}
                  />
                  <InputField
                    label="Alloted By"
                    name="alloted_by"
                    type="text"
                    placeholder="Mr. XYZ"
                    required={true}
                  />
                </div>
                <div className="py-5 flex justify-end gap-6">
                  <div>
                    <Button
                      type="button"
                      className="text-primary bg-white hover:bg-white-dark font-sm rounded-lg text-lg w-full px-8 py-1.5 text-center border border-primary"
                      onClick={() => handleDiscardChanges(resetForm)}
                      disabled={isSubmitting}
                    >
                      Discard Changes
                    </Button>
                  </div>
                  <div>
                    <Button
                      type="submit"
                      className="text-white bg-primary hover:bg-primary-dark font-sm rounded-lg text-lg w-full px-8 py-1.5 text-center"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Saving..." : "Save"}
                    </Button>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </Modal>
  );
};

export default AllotOpenMedicineAlert;
